import {useStorage} from '@vueuse/core'

const STORAGE_PREFIX = 'userPrefs.'

const HIDE_DELETED_TRANS = `${STORAGE_PREFIX}HIDE_DELETED_TRANS`

const AUTO_SAVE = `${STORAGE_PREFIX}AUTO_SAVE`
const SKIP_AUTO_SAVE = `${STORAGE_PREFIX}SKIP_AUTO_SAVE`

export type PresetSize = {
    name: string,
    height: number
}

const attachmentPresetSizes: PresetSize[] = [
    {name: 'S', height: 900},
    {name: 'M', height: 1000},
    {name: 'L', height: 1200}
]

const POPUP_POSITION = `${STORAGE_PREFIX}POPUP_POSITION`
const ATTACHMENT_POPUP_SIZE = `${STORAGE_PREFIX}ATTACHMENT_POPUP_SIZE`
const HOVER_TO_OPEN_TRANSACTION_POPUP = `${STORAGE_PREFIX}HOVER_TO_OPEN_TRANSACTION_POPUP`

const useUserPrefs = () => {
    const hideDeletedTransactions = useStorage(HIDE_DELETED_TRANS, false)

    const autoSaveDraft = useStorage(AUTO_SAVE, false)
    const skipAutoSaveDraft = useStorage(SKIP_AUTO_SAVE, false)

    const documentPreviewModalPosition = useStorage(POPUP_POSITION, {x: 100, y: 200})
    const documentPreviewModalSize = useStorage(ATTACHMENT_POPUP_SIZE, attachmentPresetSizes[1])
    const isHoverToOpenDocumentPreviewModal = useStorage(HOVER_TO_OPEN_TRANSACTION_POPUP, false)

    return {
        hideDeletedTransactions,
        autoSaveDraft,
        skipAutoSaveDraft,
        documentPreviewModalPosition,
        documentPreviewModalSize,
        isHoverToOpenDocumentPreviewModal
    }
}

export {attachmentPresetSizes, useUserPrefs}